import { Component, inject } from '@angular/core';
import { RouterLink } from "@angular/router";
import { ActiveRoute } from '../active-route';
import { ViewportEnterDirective } from '../viewport-enter-directive';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, ViewportEnterDirective],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
  activeRoute= inject(ActiveRoute);
  }
